<template>
  <div v-if="showToast" class="modal-mask" ref="privacy-policy-toast">
    <div class="modal-container">
      <v-icon dark class="modal-icon">info</v-icon>
      <div class="modal-body">
        <p>
          Our <a :href="privacyPolicyUrl" target="_blank">Privacy Policy</a>
          has been updated, effective {{privacyPolicyDate}}
        </p>
      </div>
      <div class="modal-close text-xs-right">
        <v-btn
          color="grey"
          x-large
          flat
          icon
          @click="handleClose">
          <v-icon large>clear</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Cookies from 'cookies-js';
import Moment from 'moment';

const COOKIE_NAME = 'privacyPolicyDismissed';
const PRIVACY_POLICY_URL = `${process.env.VUE_APP_HG_CLASSIC}privacy.html`;

export default {
  data() {
    return {
      privacyPolicyUrl: PRIVACY_POLICY_URL,
      privacyPolicyDate: '',
      showToast: false,
      versionDate: '',
    };
  },
  async mounted() {
    await this.initialHydration();
    this.checkToast();
  },
  computed: {
    ...mapState('User', {
      currentUserId: state => (state.currentUser ? state.currentUser.legacyId : null),
    }),
  },
  methods: {
    checkToast() {
      const privacyPolicyCookie = Cookies.get(COOKIE_NAME);
      if (!privacyPolicyCookie) {
        this.showToast = true;
      } else {
        // Cookie did not match current user or cookie older than updated privacy policy
        const parseCookie = JSON.parse(privacyPolicyCookie);
        const cookieDate = new Moment(parseCookie.date);
        if (parseCookie.user !== this.currentUserId || cookieDate.isBefore(this.versionDate)) {
          this.showToast = true;
        }
      }
    },
    handleClose() {
      const today = new Date().toISOString();
      const value = JSON.stringify({ user: this.currentUserId, date: today });
      Cookies.set(COOKIE_NAME, value);
      this.showToast = false;
    },
    async initialHydration() {
      const privacyPolicy = await this.$store.dispatch('Offers/loadPrivacyPolicy');
      this.setPrivacyPolicyVersion(privacyPolicy.version);
      // @TODO refactor dispatch 'User/loadMe' into a global solution
      await this.$store.dispatch('User/loadMe');
    },
    setPrivacyPolicyVersion(data) {
      const versionDate = new Moment(data);
      this.versionDate = versionDate;
      this.privacyPolicyDate = versionDate.format('MM/D/YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';

a {
  color: white;
  text-decoration: underline;
}

a:hover {
  cursor: pointer;
}

.modal-icon {
  padding: 17px 8px 12px 10px;
}

.modal-body {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  padding: 19px 5px 0 0;
}

.modal-close {
  padding-left: 5px;
}

.modal-container {
  color: $theme-color-white;
  font-family: $typography-font-primary;
  position: relative;
  transition: all .3s ease;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content:space-between;
  min-width: 100px;
}

.modal-mask {
  background-color: $theme-color-gray;
  display: table;
  height: 10px;
  left: 0;
  position: fixed;
  bottom: 0;
  transition: opacity .3s ease;
  width: 100%;
  z-index: 9997;
}
</style>
